import type { VerifiedVia } from "@sagot/constants";
import { Chip, type ChipSize } from "./chip";

export interface RequesterVerificationBadgeProps {
  verified: boolean;
  /** "Verified" or "Unverified", already localised. */
  label: string;
  /** How the identity was proven ("E-mail code"); shown after the label when verified. */
  methodLabel?: string;
  /** Machine value, kept as `data-method` for tests and tooling. */
  method?: VerifiedVia | null;
  size?: ChipSize;
  className?: string;
}

/**
 * Whether the requester's identity was proven, and how (scope UX-026). Verified = success + shield-check; unverified is
 * an accent signal + shield-alert (needs a look, never an error). Text always says which, so colour is never alone.
 */
export function RequesterVerificationBadge({ verified, label, methodLabel, method, size = "md", className }: RequesterVerificationBadgeProps) {
  return (
    <Chip
      tone={verified ? "success" : "accent"}
      icon={verified ? "shield-check" : "shield-alert"}
      size={size}
      className={className}
      data-verified={verified ? "true" : "false"}
      data-method={verified && method ? method : undefined}
    >
      {verified && methodLabel ? `${label} · ${methodLabel}` : label}
    </Chip>
  );
}
